/* @flow */
import idx from 'idx';
import uuid from 'uuid';
import * as React from 'react';
import Modal from 'react-modal';
import Row from 'components/Row';
import Text from 'components/Text';
import Image from 'components/Image';
import Button from 'components/ButtonDeprecated';
import Heading from 'components/Heading';
import ToastActions from 'actions/ToastActions';
import { withRouter } from 'app/context/Router';
import WizardFooter from 'components/WizardFooter';
import WizardHeader from 'components/WizardHeader';
import ConfirmDialog from 'components/ConfirmDialog';
import IntegrationWizardHeaderContent from 'admin/components/IntegrationWizardHeaderContent';

import './styles/SchoologyACI.scss';

type Props = {
  router: any,
  integration: any,
  upsert: Function,
  onDone: Function,
};

type State = {
  enabled?: ?boolean,
  showGoBackConfirmation: boolean,
};

class SchoologyACI extends React.Component<Props, State> {
  state: State = {
    showGoBackConfirmation: false,
  };

  componentDidMount() {
    this.setState({
      enabled: this.props.integration.isACIIntegrated,
    });
  }

  toogleEnabled = () => {
    this.setState({ enabled: !this.state.enabled });
  };

  goBack = () => {
    if (this.state.enabled === this.props.integration.isACIIntegrated) {
      this.props.router.goBack();
      return;
    }

    this.setState({ showGoBackConfirmation: true });
  };

  submit = () => {
    const key = idx(this.props.integration, _ => _.adminCustomizedIntegrationSetup.integrationKey);

    this.props
      .upsert({
        initialIntegrationKey: key ? undefined : uuid(),
        enabledByOrg: this.state.enabled,
      })
      .then(response => {
        const error = idx(response, _ => _.data.upsertAdminControlledIntegration.error.message);

        if (error) {
          ToastActions.showErrorToast(error);
        } else if (this.state.enabled) {
          this.props.onDone();
        } else {
          this.props.router.goBack();
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  render() {
    return (
      <div className="SchoologyACI">
        <Modal isOpen={this.state.showGoBackConfirmation}>
          <ConfirmDialog
            size="small"
            cancelButtonText="Cancel"
            title="You have unsaved change."
            subtext="Are you sure you want to exit?"
            actionButtonText="Yes, exit without saving"
            onConfirm={() => this.props.router.goBack()}
            onCancel={() => this.setState({ showGoBackConfirmation: false })}
            onRequestHide={() => this.setState({ showGoBackConfirmation: false })}
          />
        </Modal>
        <WizardHeader>
          <IntegrationWizardHeaderContent
            title="Schoology Setup"
            iconURL={this.props.integration.iconURL}
          />
        </WizardHeader>
        <div className="SchoologyACI-content">
          <Row>
            <Heading level="1" levelStyle="1">
              Enable Schoology for your district
            </Heading>
            <Row size="small">
              <Text element="div" size="medium" className="SchoologyACI-content-text">
                Enable everyone in your district to connect to their Schoology accounts. Once
                enabled, users will be able to connect to their personal Schoology accounts to
                access and share Schoology resources within Remind.
              </Text>
            </Row>
            {!this.state.enabled && <Button onClick={this.toogleEnabled}>Enable Schoology</Button>}
            {this.state.enabled && (
              <Button onClick={this.toogleEnabled} level="secondary" color="apple">
                Disable Schoology
              </Button>
            )}
          </Row>
          <Row>
            <Heading level="2" levelStyle="2">
              Using Schoology on Web
            </Heading>
            <Row>
              <Text element="div" size="medium" className="SchoologyACI-content-text">
                Once enabled, Schoology will appear in the attachment card within the composer. From
                there, you can access and send attachments directly from your Schoology account when
                you compose messages on Remind.{' '}
              </Text>
            </Row>
            <div className="SchoologyACI-content-images">
              <Image src={require('assets/images/schoology_aci_composer_1.png')} />
              <Image src={require('assets/images/schoology_aci_composer_2.png')} />
            </div>
          </Row>
          <Heading level="2" levelStyle="2">
            Schoology on iOS and Android
          </Heading>
          <Row>
            <Text element="div" size="medium" className="SchoologyACI-content-text">
              Once enabled, Schoology will appear in the attachment card within the composer. From
              there, you can access and send attachments directly from your Schoology account when
              you compose messages on Remind.
            </Text>
          </Row>
          <div className="SchoologyACI-content-images">
            <Image src={require('assets/images/schoology_aci_iphone_1.png')} />
            <Image src={require('assets/images/schoology_aci_iphone_2.png')} />
          </div>
        </div>
        <WizardFooter>
          <div className="SchoologyACI-footer">
            <Button level="secondary" onClick={this.goBack}>
              Back
            </Button>
            <Button
              onClick={this.submit}
              disabled={this.state.enabled === this.props.integration.isACIIntegrated}>
              Save
            </Button>
          </div>
        </WizardFooter>
      </div>
    );
  }
}

export default withRouter(SchoologyACI);
